import { root } from './state';

export const state = {
  ...root,
};
